import React from 'react';
import './header.css';
import '../../pages/home.css';
import { Link } from 'react-router-dom';
import HamburgerComp from './Hamburger';

const Header = () => {
    return ( 
        <>
        <header className='fixed'>
            <nav>
                <ul>
                    <Link className='headerLogo' to="/">AXIS</Link>
                    <HamburgerComp />
                </ul>
            </nav>
        </header>
        </>
     );
}
 
export default Header;